<template>
  <div
    class="page-default  overflow-auto"
    style="height: 100vh"
  >
    <div class="d-flex justify-content-between px-4 py-3">
      <div class="position-relative d-block" style="width: calc(100% - 300px)">
        <div
          class="bg-dark rounded border-outline-dark-all overflow-hidden d-flex justify-content-between align-items-center shadow mb-2"
        >
          <input
            type="text"
            class="w-100 bg-dark border-0 text-light form-control"
            placeholder="Search user by: [Email]"
            :disabled="isProcessing"
            v-model="searching"
            id="searching"
          />
          <!-- <button
            v-if="searching.length == 0"
            type="button"
            class="btn btn-dark  mr-1"
            @click="handleSearching(searching)"
          >
            <font-awesome-icon :icon="['fas', 'search']" class="align-middle" />
          </button> -->
          <button
            v-if="searching.length > 0"
            type="button"
            class="btn btn-dark mr-1"
            @click="searching = ''"
          >
            <font-awesome-icon :icon="['fas', 'times']" class="align-middle" />
          </button>
        </div>
        <div
          class="bg-dark p-2 rounded shadow position-relative d-block overflow-auto"
          style="height: calc(100vh - 185px)"
        >
          <table class="table table-sm table-bordered rounded mb-0 table-hover">
            <thead>
              <tr>
                <th
                  style="width: 200px !important"
                  class="fit-content bg-dark border border-outline-dark-all text-light"
                >
                  Name
                </th>
                <th
                  style="width: 200px !important"
                  class="fit-content bg-dark border border-outline-dark-all text-light"
                >
                  Email
                </th>
                <th
                  style="width: 200px !important"
                  class="fit-content bg-dark border border-outline-dark-all text-light"
                >
                  Role
                </th>
                <th
                  style="width: 200px !important"
                  class="fit-content bg-dark border border-outline-dark-all text-light"
                >
                  District
                </th>
                <th
                  style="width: 200px !important"
                  class="fit-content bg-dark border border-outline-dark-all text-light"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(user, idx) in users" :key="user.id">
                <td
                  class="px-3 fit-content text-light border border-outline-dark-all"
                >
                  {{ idx + 1 }}.
                  {{ user.name }}
                </td>
                <td
                  class="px-3 fit-content text-light border border-outline-dark-all text-primary"
                  style="text-decoration: underline"
                >
                  {{ user.email }}
                </td>
                <td
                  class="px-3 fit-content text-light border border-outline-dark-all"
                  v-if="user.role"
                >
                  {{ user.role.name }}
                </td>
                <td
                  class="px-3 fit-content text-light border border-outline-dark-all"
                  v-else
                >
                  -
                </td>
                <td
                  class="px-3 fit-content text-light border border-outline-dark-all"
                  v-if="user.districts && user.districts.length > 0"
                >
                  <span
                    v-for="itemDistrict in user.districts"
                    :key="itemDistrict.id"
                    class="badge badge-pill badge-warning mr-1"
                    >{{ itemDistrict.name }}</span
                  >
                </td>
                <td
                  class="px-3 fit-content text-light border border-outline-dark-all"
                  v-else
                >
                  -
                </td>
                <td
                  class="px-3 fit-content text-light border border-outline-dark-all"
                >
                  <button
                    type="button"
                    class="btn btn-dark"
                    @click="openModal(user)"
                  >
                    <font-awesome-icon :icon="['far', 'edit']" />
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <div
            style="opacity: 0.3"
            v-if="users.length == 0"
            class="position-relative h-100 w-100 justify-content-center text-muted text-center align-items-center d-flex"
          >
            <div>
              <font-awesome-icon
                :icon="['fas', 'inbox']"
                class="text-muted fa-6x"
              />
              <div>
                <p>User not found.</p>
              </div>
            </div>
          </div>
        </div>
        <div
          class="d-flex justify-content-center align-items-center w-100 mt-3"
          v-if="totalPage.length > 1"
        >
          <nav aria-label="Page navigation example ">
            <ul class="pagination m-0 shadow rounded overflow-hidden">
              <li class="page-item" v-for="pg in totalPage" :key="pg">
                <button
                  type="button"
                  class="btn text-light rounded-0"
                  :class="pg == page + 1 ? 'bg-primary' : 'bg-dark'"
                  @click="page = pg - 1"
                >
                  {{ pg }}
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div class="position-relative d-block ml-2" style="width: 300px">
        <div class="bg-dark p-2 rounded shadow w-100">
          <div class="d-flex px-2">
            <button
              type="button"
              class="btn btn-primary w-100"
              @click="openModal(null)"
            >
              Create new User
            </button>
          </div>
          <hr />
          <div class="px-2">
            <h5 class="text-light">Filters</h5>
            <!-- role -->
            <p class="mb-1 text-light mt-3">Role</p>
            <div class="btn-group w-100">
              <button
                type="button"
                class="btn btn-dark dropdown-toggle w-100"
                data-toggle="dropdown"
                aria-expanded="false"
                :disabled="roles.length == 0"
              >
                {{ selectedRole ? selectedRole.name : "Select Role" }}
              </button>
              <div class="dropdown-menu dropdown-menu-right w-100">
                <button
                  class="dropdown-item text-muted w-100"
                  type="button"
                  @click="handleClickRole(null)"
                >
                  {{ !selectedRole ? "Select Role" : "Deselect Role" }}
                </button>
                <button
                  class="dropdown-item text-light w-100"
                  :class="
                    selectedRole && selectedRole.name == role.name
                      ? 'bg-primary'
                      : ''
                  "
                  type="button"
                  v-for="role in roles"
                  :key="role.id"
                  @click="handleClickRole(role)"
                >
                  {{ role.name }}
                </button>
              </div>
            </div>
            <!-- districts -->
            <p class="mb-1 text-light mt-3">Districts</p>
            <div class="btn-group w-100">
              <button
                type="button"
                class="btn btn-dark dropdown-toggle w-100"
                data-toggle="dropdown"
                aria-expanded="false"
                :disabled="districts.length == 0"
              >
                {{
                  selectedDistricts ? selectedDistricts.name : "Select District"
                }}
              </button>
              <div class="dropdown-menu dropdown-menu-right w-100">
                <button
                  class="dropdown-item text-muted w-100"
                  type="button"
                  @click="handleClickDistrict(null)"
                >
                  {{
                    !selectedDistricts ? "Select District" : "Deselect District"
                  }}
                </button>
                <button
                  class="dropdown-item text-light w-100"
                  :class="
                    selectedDistricts && selectedDistricts.name == district.name
                      ? 'bg-primary'
                      : ''
                  "
                  type="button"
                  v-for="district in districts"
                  :key="district.id"
                  @click="handleClickDistrict(district)"
                >
                  {{ district.name }}
                </button>
              </div>
            </div>
            <button
              type="button"
              class="btn bg-dark w-100 mt-3"
              :class="
                !selectedRole && !selectedDistricts && searching.length == 0
                  ? 'text-muted'
                  : 'text-danger'
              "
              :disabled="
                !selectedRole && !selectedDistricts && searching.length == 0
              "
              @click="clearFilter()"
            >
              Clear filter
            </button>
          </div>
        </div>
      </div>
    </div>
    <edit-user
      :show="showModal"
      @close="closeModal()"
      :user="selectedUser"
      :roles="roles"
      :districts="districts"
      :getUsers="getUsers"
    />
    <spinner v-if="isProcessing" />
  </div>
</template>

<script>
import $ from "jquery";
import API from "@/api";
import Spinner from "@/components/Spinner";
import EditUser from "../modals/EditUser.vue";

export default {
  name: "users",
  components: {
    Spinner,
    EditUser,
  },
  data() {
    return {
      isProcessing: false,
      users: [],
      roles: [],
      districts: [],
      searching: "",
      selectedRole: null,
      selectedDistricts: null,
      page: 0,
      totalPage: [],
      showModal: false,
      selectedUser: null,
      timeoutSearch: 0,
    };
  },
  watch: {
    page: {
      async handler() {
        await this.getUsers(this.page);
      },
    },
    selectedRole: {
      async handler() {
        await this.getUsers();
      },
    },
    selectedDistricts: {
      async handler() {
        await this.getUsers();
      },
    },
    searching: {
      handler() {
        if (this.timeoutSearch) {
          clearTimeout(this.timeoutSearch);
        }

        this.timeoutSearch = setTimeout(async () => {
          if (!this.searching) {
            await this.getUsers();
          } else {
            await this.getUsers();
          }
        }, 500);
      },
    },
  },
  methods: {
    closeModal() {
      this.showModal = false;
      this.selectedUser = null;
    },
    openModal(user) {
      this.showModal = !this.showModal;
      this.selectedUser = user;
    },
    clearFilter() {
      this.searching = "";
      this.selectedRole = null;
      this.selectedDistricts = null;
    },
    handleClickRole(role) {
      this.selectedRole = role;
    },
    handleClickDistrict(district) {
      this.selectedDistricts = district;
    },
    getUsers(pageNum) {
      if (!pageNum) this.page = 0;

      this.isProcessing = true;
      let params = "";
      let url = new URLSearchParams(params);

      if (this.selectedRole && this.selectedRole.id) {
        url.set(`_where[0][role]`, this.selectedRole.id);
      }

      if (this.selectedDistricts && this.selectedDistricts.id) {
        url.set(`_where[1][districts]`, this.selectedDistricts.id);
      }
      url.set(`_start`, this.page * 50);
      url.set(`_limit`, 50);

      if (this.searching) {
        url.set(`email_contains`, this.searching);
      }

      API.get(`usersOnly?${url.toString()}`)
        .then((result) => {
          this.users = result.data;
          this.isProcessing = false;
        })
        .catch((err) => {
          this.isProcessing = false;
          this.users = [];
        });

      API.get(`users/count?${url.toString()}`)
        .then((result) => {
          let total = Math.ceil(result.data / 50);
          let c = [];
          for (let i = 0; i < total; i++) {
            c.push(i + 1);
          }
          this.totalPage = c;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getRoles() {
      API.get(`users-permissions/roles`).then((result) => {
        this.roles = result.data.roles.filter((x) => x.name != "Public");
      });
    },
    getDistricts() {
      let availableDistrict = [
        "Sepang",
        "Sabak Bernam",
        "Petaling",
        "Kuala Selangor",
        "Kuala Langat",
        "Klang",
        "Hulu Selangor",
        "Hulu Langat",
        "Gombak",
      ];
      API.get(`districts`).then((result) => {
        let newdata = [];
        availableDistrict.forEach((d) => {
          result.data.forEach((x) => {
            if (x.name.toLowerCase().includes(d.toLowerCase())) {
              newdata.push(x);
            }
          });
        });
        this.districts = newdata;
      });
    },
  },
  async mounted() {
    $("searching").attr("autocomplete", "off");
    await this.getDistricts();
    await this.getRoles();
    await this.getUsers();
  },
};
</script>